import React, { useEffect } from 'react';
import { useAuthentication } from './authentication/authentication-hook';

export default function LoggedOut() {
    const {
        logout,
        isAuthenticated,
    } = useAuthentication();

    useEffect(() => {
        if (isAuthenticated) {
            logout({
                redirectUri: `${ window.location.origin }/logout`,
            });

            return;
        }
    }, [ isAuthenticated ]);

    if (isAuthenticated) {
        return (
            <p>Please wait while you're being logged out...</p>
        )
    }

    return (
        <p>You have been logged out</p>
    );
}
